import React, { useCallback, useEffect, useState } from "react";
import { StyledWelcomeBanner, StyledWrapper } from "../../dashboard/style";
import { adminStatisticsData, statisticsTitles } from "../../dashboard/constant";
import {DashboardStatistics} from "../../../components/admin/dashboard/StatisticsComponent";
import OrderTable from "../../../components/common/table/OrderTable";
import {
  StyledHeader,
  StyledOrdersContainer,
  StyledTitle,
  StyledTitleContainer,
} from "../../../components/orders-dashboard/style";
// import OrderTableHeader from "../../../components/common/table/OrderTableHeader";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/common/loader/Loader";
import { useNavigate } from "react-router-dom";
import { ADMIN_DASHBOARD_COUNT } from "../../../actions/admin/AdminActions";
import { ORDER_LIST/*, GROUP_CART_MONITORING_LIST*/ } from "../../../actions/admin/customer-actions";
import { IconButton, TablePagination, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import {
  ORDER_LIST_COLUMNS,
  normalizeOrderStatus,
  resolveCarrier,
  resolveTrackingNumber,
  resolveTrackingUrl,
} from "../../../utils/orderListTable";
import {
  formatOrderDisplayStatusLabel,
  getOrderDisplayStatusBackground,
} from "../../../utils/orderDisplayStatus";

const CustomerManagement = () => {
  const dispatch = useDispatch();
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const { dashboardCount, recordList: orderList, total: orderTotal, /*groupCartList, groupCartTotal,*/ isLoading } = useSelector((state) => state?.orderData);
  const isProfileLoading = useSelector((state) => state?.auth?.isMeLoading);
  const userType = profileDetails?.user_type;
  const isAdmin = userType === "admin";
  const navigate = useNavigate();
  const [statisticsData, setStatisticsData] = useState(adminStatisticsData);

  const [orderPage, setOrderPage] = useState(1);
  const [orderRowsPerPage, setOrderRowsPerPage] = useState(10);
  // const [groupCartPage, setGroupCartPage] = useState(1);
  // const [groupCartRowsPerPage, setGroupCartRowsPerPage] = useState(10);

  const orderListFunc = useCallback(() => {
    dispatch({
      type: ORDER_LIST,
      payload: { search: "", page: orderPage, limit: orderRowsPerPage },
    });
  }, [dispatch, orderPage, orderRowsPerPage]);

  useEffect(() => {
    if (isProfileLoading || !userType) return;
    if (!isAdmin) navigate('/login', { replace: true });
  }, [isAdmin, isProfileLoading, navigate, userType]);

  useEffect(() => {
    dispatch({ type: ADMIN_DASHBOARD_COUNT });
  }, [dispatch]);

  useEffect(() => {
    orderListFunc();
  }, [orderListFunc]);

  // useEffect(() => {
  //   dispatch({ type: GROUP_CART_MONITORING_LIST, payload: { search: "", page: groupCartPage, limit: groupCartRowsPerPage } });
  // }, [dispatch, groupCartPage, groupCartRowsPerPage]);

  useEffect(() => {
    if (!dashboardCount) return;
    const updated = adminStatisticsData.map((item) => {
      switch (item.title) {
        case statisticsTitles.todaysOrder:
          return { ...item, value: dashboardCount?.orderCount?.today_orders ?? 0 };
        case statisticsTitles.totalRequestsMade:
          return { ...item, value: dashboardCount?.orderCount?.total_request_made ?? 0 };
        case statisticsTitles.ordersCompleted:
          return { ...item, value: dashboardCount?.orderCount?.order_completed ?? 0 };
        case statisticsTitles.ordersInProgress:
          return { ...item, value: dashboardCount?.orderCount?.order_in_progress ?? 0 };
        case statisticsTitles.totalCustomers:
          return { ...item, value: dashboardCount?.customerCount?.total_customers ?? 0 };
        default:
          return item;
      }
    });
    setStatisticsData(updated);
  }, [dashboardCount]);

  // const paymentOptionLabels = {
  //   manual_split: "Manual Split",
  //   auto_split: "Auto Split",
  //   consolidated: "Consolidated",
  // };

  const columns = [...ORDER_LIST_COLUMNS, "ACTION"];

  const allRecords =
    (!isAdmin ? [] : orderList)?.map((item) => {
      const orderStatus = normalizeOrderStatus(item.order_status);
      const isAllApproved = item.order_details?.length > 0 && item.order_details.every((d) => d.item.status === "approved");
      return {
        id: item.id,
        order_number: item.order_number,
        approved_items_count: Number(item.approved_items_count) || 0,
        tracking_number: resolveTrackingNumber(item),
        carrier: resolveCarrier(item),
        tracking_url: resolveTrackingUrl(item),
        items: item.order_details?.map((d) => d.itemId),
        activeStatus: orderStatus,
        payment_status: item.payment_status,
        status: (
          <>
            <span
              style={{
                backgroundColor: getOrderDisplayStatusBackground(item),
                fontWeight: "bold",
                display: "inline-block",
                color: "white",
                padding: "4px 8px",
                borderRadius: "20px",
                minWidth: "90px",
                textAlign: "center",
              }}
            >
              {formatOrderDisplayStatusLabel(item)}
            </span>
            {(isAllApproved && orderStatus === "pending") && (
              <Tooltip title="All order items are approved — you can approve this order" arrow>
                <IconButton>
                  <InfoIcon color="primary" />
                </IconButton>
              </Tooltip>
            )}
          </>
        ),
      };
    }) || [];

  if (isLoading) return <Loader />;

  return (
    <StyledWrapper>
      <StyledWelcomeBanner>
        <DashboardStatistics idDataList={statisticsData || []} hideFooter />
      </StyledWelcomeBanner>

      <StyledOrdersContainer>
        {/* <OrderTableHeader
          tabLabels={tabLabels}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          responsiveMode
        /> */}
        <StyledHeader
          sx={{
            mb: 2.5,
            pb: 1.5,
            borderBottom: (theme) => `2px solid ${theme.palette.custom.primary}`,
          }}
        >
          <StyledTitleContainer>
            <StyledTitle
              sx={{
                fontSize: { xs: "1rem", sm: "1.125rem" },
                fontWeight: 700,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                textAlign: "left",
              }}
            >
              Orders
            </StyledTitle>
          </StyledTitleContainer>
        </StyledHeader>
        <OrderTable
          columns={columns}
          rows={allRecords}
          recordList={orderListFunc}
          orderDetailBasePath="/admin/orders"
        />
        <TablePagination
          component="div"
          count={orderTotal || 0}
          page={orderPage - 1}
          onPageChange={(_, newPage) => setOrderPage(newPage + 1)}
          rowsPerPage={orderRowsPerPage}
          onRowsPerPageChange={(e) => {
            setOrderRowsPerPage(parseInt(e.target.value, 10));
            setOrderPage(1);
          }}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </StyledOrdersContainer>
    </StyledWrapper>
  );
};

export default CustomerManagement;
